import {
  type AgentFormValues,
  BankAccountFormValues,
  BusinessAddressFormValues,
  BusinessDetailsFormValues,
  BusinessDocumentsFormValues,
  OfficeAddressFormValues,
  OwnershipFormValues,
} from './schemas';
import { StoreData } from './stores-data';

export const sectionNames = {
  ownership: 'ownership',
  businessInfo: 'businessInfo',
  registeredAddress: 'registeredAddress',
  headOfficeAddress: 'headOfficeAddress',
  businessDocuments: 'businessDocuments',
  bankDetails: 'bankDetails',
  pointsOfSales: 'pointsOfSales',
  agents: 'agents',
} as const;

export type SectionName = (typeof sectionNames)[keyof typeof sectionNames];

export type ApplicationFormValues = {
  [sectionNames.ownership]: OwnershipFormValues;
  [sectionNames.businessInfo]: BusinessDetailsFormValues;
  [sectionNames.registeredAddress]: BusinessAddressFormValues;
  [sectionNames.headOfficeAddress]: OfficeAddressFormValues;
  [sectionNames.businessDocuments]: BusinessDocumentsFormValues;
  [sectionNames.bankDetails]: BankAccountFormValues;
  [sectionNames.pointsOfSales]: StoreData[];
  [sectionNames.agents]: AgentFormValues[];
};
